
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/dummy.js';
            vueApps['app/dummy.js'] = App1;
        

            import App2 from './offer-carousel.js';
            vueApps['offer-carousel.js'] = App2;
        

            import App3 from './blog-carousel.js';
            vueApps['blog-carousel.js'] = App3;
        

            import App4 from './app/search.js';
            vueApps['app/search.js'] = App4;
        

            import App5 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App5;
        

            import App6 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App6;
        

            import App7 from './app/navbar.js';
            vueApps['app/navbar.js'] = App7;
        

            import App8 from './app/region.js';
            vueApps['app/region.js'] = App8;
        

            import App9 from './app/startPageUnits.js';
            vueApps['app/startPageUnits.js'] = App9;
        

            import App10 from './app/blogUnits.js';
            vueApps['app/blogUnits.js'] = App10;
        

            import App11 from './app/unitsForPets.js';
            vueApps['app/unitsForPets.js'] = App11;
        

            import App12 from './app/searchborn.js';
            vueApps['app/searchborn.js'] = App12;
        

            import App13 from './app/NeueHauser.js';
            vueApps['app/NeueHauser.js'] = App13;
        

        
                import Comp14 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp14);
            

                import Comp15 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp15);
            

                import Comp16 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp16);
            

                import Comp17 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp17);
            

                import Comp18 from './comp/childrenage.vue';
                Vue.component('childrenage',Comp18);
            

                import Comp19 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp19);
            

                import Comp20 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp20);
            

                import Comp21 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp21);
            

                import Comp22 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp22);
            

                import Comp23 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp23);
            

                import Comp24 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp24);
            

                import Comp25 from './comp/CookieBox.vue';
                Vue.component('voffice-cookie-box',Comp25);
            

                import Comp26 from './comp/SearchFilterTokens-v2.vue';
                Vue.component('search-filter-tokens-v2',Comp26);
            

                import Comp27 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp27);
            

                import Comp28 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp28);
            

                import Comp29 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp29);
            

                import Comp30 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp30);
            

                import Comp31 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp31);
            

                import Comp32 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp32);
            

                import Comp33 from './comp/IncreaseNumber.vue';
                Vue.component('increase-number',Comp33);
            

                import Comp34 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp34);
            

                import Comp35 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp35);
            

                import Comp36 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp36);
            

                import Comp37 from './offershelp.vue';
                Vue.component('offer-help',Comp37);
            

                import Comp38 from './pricehelp.vue';
                Vue.component('price-help',Comp38);
            

                import Comp39 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp39);
            

                import Comp40 from './feedback-carousel.vue';
                Vue.component('feedback-carousel',Comp40);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    